import React from 'react';
import Header from '../../components/ui/Header';
import QuickContactWidget from '../../components/ui/QuickContactWidget';

// Import all landing page components
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ProblemSection from './components/ProblemSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import DiscountSection from './components/DiscountSection';
import LocationsSection from './components/LocationsSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="pt-20">
        {/* Hero Section */}
        <HeroSection />

        {/* Trust Bar */}
        <TrustBar />

        {/* Problem Section */}
        <ProblemSection />

        {/* Services Section */}
        <ServicesSection />

        {/* Pricing Section */}
        {/* <PricingSection /> */}

        {/* Discount Section */}
        {/* <DiscountSection /> */}

        {/* Locations Section */}
        <LocationsSection />

        {/* Gallery Section */}
        {/* <GallerySection /> */}

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* FAQ Section */}
        <FAQSection />

        {/* Contact Section */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Quick Contact Widget */}
      <QuickContactWidget />
    </div>
  );
};

export default LandingPage;